<template>
  <div v-bind="$attrs" align="center" justify="center" class="ma-0 pa-0">
    <v-progress-linear :indeterminate="true"></v-progress-linear>
    <v-card-text justify="center" align="center" :class="IF.MyFont" :value="true" color="default">{{ text }}</v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Данните се зареждат, моля изчакайте!",
    },
  },
};
</script>

<style>
</style>